import React, { useState } from 'react'
import TableCell from '@mui/material/TableCell'
import TableRow from '@mui/material/TableRow'
import makeStyles from '@mui/styles/makeStyles'
import { Link } from 'react-router-dom'
import { IconButton, Tooltip } from '@mui/material'
import { Colors } from '../../Utils/theme'
import DeleteIcon from '../../Assets/Icons/delete.svg'
import RestoreIcon from '../../Assets/Icons/restore.svg'
import { useTranslation } from 'react-i18next'
import { Dialog } from '..'
import { formatDateTime } from '../../Utils/dateTime'

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: Colors.backgroundGrey,
    borderBottom: 'none',
    '&:hover': {
      backgroundColor: `${Colors.tableHover} !important`
    }
  },
  firstCell: {
    fontFamily: 'Roboto',
    fontSize: '1rem',
    fontWeight: 600,
    height: '3rem',
    color: Colors.black,
    borderTopLeftRadius: 5,
    borderBottomLeftRadius: 5,
    borderBottom: 'none'
  },
  lastCell: {
    height: '3rem',
    borderTopRightRadius: 5,
    borderBottomRightRadius: 5,
    borderBottom: 'none',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center'
  },
  cell: {
    fontFamily: 'Roboto',
    fontSize: '1rem',
    fontWeight: 300,
    height: '3rem',
    color: Colors.black,
    borderBottom: 'none'
  },
  link: {
    display: 'block',
    textDecoration: 'none',
    padding: '.5rem 0',
    color: Colors.black,
    '&:hover': {
      opacity: 0.8
    }
  },
  deleteButton: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: Colors.white,
    borderRadius: '0.3125rem',
    border: `1px solid ${Colors.black20}`,
    height: '2rem',
    width: '2rem',
    //paddingLeft: '0.825rem',
    '&:hover': {
      backgroundColor: `${Colors.white} !important`
    }
  },
  restoreButton: {
    backgroundColor: Colors.white,
    borderRadius: '0.3125rem',
    border: `1px solid ${Colors.black20}`,
    height: '2rem',
    width: '2rem',
  },
  actionIcon: {
    height: 'auto',
    width: '1rem',
    maxHeight: '1rem',
    maxWidth: '1rem'
  },
}))

function PollTableRow (props: any) {
  const { item } = props
  const classes = useStyles()

  const { t } = useTranslation()

  const [confirmDeleteVisible, setConfirmDeleteVisible] = useState(false)
  const [confirmRestoreVisible, setConfirmRestoreVisible] = useState(false)

  const handleDelete = () => {
    if (confirmDeleteVisible) {
      setConfirmDeleteVisible(false)
      props.onDelete(item.id)
    } else {
      setConfirmDeleteVisible(true)
    }
  }

  const handleRestore = () => {
    if (confirmRestoreVisible) {
      setConfirmRestoreVisible(false)
      props.onRestore(item.id)
    } else {
      setConfirmRestoreVisible(true)
    }
  }

  const closeConfirms = () => {
    setConfirmDeleteVisible(false)
    setConfirmRestoreVisible(false)
  }

  const renderActions = () => {
    if (item.active) {
      // Delete button
      return (
        <>
          <Tooltip title={t('delete')}>
            <IconButton onClick={handleDelete} className={classes.deleteButton} size="large">
              <img src={DeleteIcon} alt='icon' className={classes.actionIcon} />
            </IconButton>
          </Tooltip>
          <Dialog
            open={confirmDeleteVisible}
            handleClose={closeConfirms}
            handleOk={handleDelete}
            title={t('delete_poll_title')}
            description={t('delete_poll_description')}
          />
        </>
      )
    } else {
      // Restore button
      return (
        <>
          <Tooltip title={t('restore')}>
            <IconButton onClick={handleRestore} className={classes.restoreButton} size="large">
              <img src={RestoreIcon} alt='icon' className={classes.actionIcon} />
            </IconButton>
          </Tooltip>
          <Dialog
            open={confirmRestoreVisible}
            handleClose={closeConfirms}
            handleOk={handleRestore}
            title={t('activate_poll_title')}
            description={t('activate_poll_description')}
          />
        </>
      )
    }
  }

  return (
    <TableRow classes={{ root: classes.root }} hover>
      <TableCell className={classes.firstCell} size='small'>
        <Link to={`/poll/${item.id}`} className={classes.link}>
          {item.titleFi}
        </Link>
      </TableCell>
      <TableCell className={classes.cell} size='small'>
        <Link to={`/poll/${item.id}`} className={classes.link}>
          {item.totalAnswers}
        </Link>
      </TableCell>
      <TableCell className={classes.cell} size='small'>
        <Link to={`/poll/${item.id}`} className={classes.link}>
          {item.validFrom ? formatDateTime(item.validFrom) : ''}
        </Link>
      </TableCell>
      <TableCell className={classes.cell} size='small'>
        <Link to={`/poll/${item.id}`} className={classes.link}>
          {item.validUntil ? formatDateTime(item.validUntil) : ''}
        </Link>
      </TableCell>
      <TableCell className={classes.lastCell} size='small'>
        {renderActions()}
      </TableCell>
    </TableRow>
  )
}

export default PollTableRow
